import {ListModel} from '../../shared/models/list.model';
import {Utilities} from '../../shared/utilities/utilities.model';
import {NotificationItemList} from './notification-item-list.model';
/**
 * Created by wladimir on 22/05/18.
 */

export class NotificationsList  {

	public stats: NotificationsStats;
	public items: NotificationItemList[];

	constructor(model?: any) {
		this.items = [];
		if (!Utilities.isVoid(model)) {
			if (!Utilities.isVoid(model.items)) {
				model.items.forEach(notification => this.items.push(new NotificationItemList(notification)));
			}
			if (!Utilities.isVoid(model.stats)) {
				this.stats = new NotificationsStats(model.stats);
			}
		}
	}
}

export class NotificationsStats {
	item_count: number;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.item_count = model.item_count;
		}
	}
}

export class NotificationsStatsPolling {
    total_unread: number;
    total_unread_new: number;


    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.total_unread = model.total_unread;
            this.total_unread_new = model.total_unread_new;
        }
    }
}

export class NotificationsListPolling {
    public stats: NotificationsStatsPolling;
    public items: NotificationItemList[];

    constructor(model?: any) {
        this.items = [];
        if (!Utilities.isVoid(model)) {
            if (!Utilities.isVoid(model.items)) {
                model.items.forEach(notification => this.items.push(new NotificationItemList(notification)));
            }
            if (!Utilities.isVoid(model.stats)) {
                this.stats = new NotificationsStatsPolling(model.stats);
            }
        }
    }
}
